enum RoleEnum {
	'OPS' = 'OPS',
	'SUPPORT' = 'SUPPORT',
	'PRODUCT' = 'PRODUCT'
}

export default RoleEnum
